import { render } from "./Prompts.vue?vue&type=template&id=6c064432&scoped=true"
import script from "./Prompts.vue?vue&type=script&lang=js"
export * from "./Prompts.vue?vue&type=script&lang=js"

import "./Prompts.vue?vue&type=style&index=0&id=6c064432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c064432"]])

export default __exports__